import { useLocation } from 'react-router-dom';
import EmbedPlayer from './EmbedPlayer';

const Embed = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const uid = searchParams.get('uid');
  const type = searchParams.get('type');
  const redirect = (searchParams.get('redirect') || 'true') === 'true';
  // Lets an embedder bake the pathkey digest into the embed URL so viewers
  // never meet the form. Cookies cannot do this job in a third-party iframe.
  const pathKey = searchParams.get('path_key');

  return (
    <EmbedPlayer
      uid={uid}
      type={type}
      redirect={redirect}
      initialPathKey={pathKey}
    />
  );
};

export default Embed;
